import { IconButton, Outside, UIText1, UIText2 } from '@cian/ui-kit';
import { IconActionMore16, IconFileTrash16, IconFileEdit16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './ReplyTemplateItemMobile.css';

import type { IReplyTemplate } from '../../types/replyTemplates';

type TReplyTemplateItemMobileProps = {
  template: IReplyTemplate;
  onClick: () => void;
  onEdit: () => void;
  onDelete: () => void;
};

export const ReplyTemplateItemMobile: React.FC<TReplyTemplateItemMobileProps> = ({
  template,
  onClick,
  onEdit,
  onDelete,
}) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const menuRef = React.useRef<HTMLDivElement>(null);
  const menuWrapperRef = React.useRef<HTMLDivElement>(null);

  const handleMenuToggle = React.useCallback(() => {
    setIsMenuOpen(prev => !prev);
  }, []);

  const handleCloseMenu = React.useCallback(() => {
    setIsMenuOpen(false);
  }, []);

  return (
    <div className={styles['container']}>
      <div className={styles['content']} onClick={onClick}>
        {template.name && <UIText2 color="text-secondary-default">{template.name}</UIText2>}
        <UIText1 color="text-primary-default">{template.text}</UIText1>
      </div>

      <div
        ref={menuWrapperRef}
        className={classNames(styles['menu-wrapper'], isMenuOpen && styles['menu-wrapper-open'])}
      >
        {isMenuOpen && (
          <Outside onOutside={handleCloseMenu} active insideRefs={[menuRef, menuWrapperRef]}>
            <div ref={menuRef} className={styles['actions']}>
              <div className={styles['icon-action']}>
                <IconButton
                  icon={<IconFileEdit16 color="icon-main-default" />}
                  onClick={onEdit}
                  data-name="ReplyTemplateItemEdit"
                />
              </div>
              <div className={styles['icon-action']}>
                <IconButton
                  icon={<IconFileTrash16 color="icon-negative-default" />}
                  onClick={onDelete}
                  data-name="ReplyTemplateItemDelete"
                />
              </div>
            </div>
          </Outside>
        )}
        <div className={styles['icon-more']}>
          <IconButton icon={<IconActionMore16 />} onClick={handleMenuToggle} data-name="ReplyTemplateItemMore" />
        </div>
      </div>
    </div>
  );
};
